import {
  GET_CATEGORIES_REQUEST,
  GET_CATEGORIES_RESPONSE,
  GET_CATEGORIES_SUCCESS,
} from './types';
export default function (
  state = {
    requestingCategories: false,
    response: null,
  },
  action
) {
  switch (action.type) {
    case GET_CATEGORIES_REQUEST:
      return { ...state, requestingCombos: true };
    case GET_CATEGORIES_RESPONSE:
      return { ...state, requestingCombos: false, response: action.response };
    default:
      return state;
  }
}
